export default {
  "tvGuide": "TV Guide",
  "viewLocationDetails": "View location details",
  "locationValue": "Location: {{value}}",
  "loadingLocation": "Loading location...",
  "locationUnavailable": "Location data unavailable",
  "hideDetails": "Hide details",
  "showDetails": "Show details",
  "requestFailed": "Request failed",
  "awaitingApproval": "Awaiting approval.",
  "approvedNotYetDownloaded": "Approved, not yet downloaded.",
  "partiallyAvailable": "Partially available.",
  "requestDenied": "Request denied.",
  "requestFailed2": "Request failed.",
  "available": "Available.",
  "fulfilledEarlierNotVerifiedInYourLibrary": "Fulfilled earlier; not verified in your library.",
  "statusCouldNotBeDetermined": "Status could not be determined.",
  "mediaRequests": "Media Requests",
  "inYourLibrary": "In your library",
  "theRequestManagerSuppliedNoTitleForThisRequest": "The request manager supplied no title for this request, so it is identified by its external id.",
  "titleUnavailableFromTheRequestManager": "Title unavailable from the request manager",
  "approve": "Approve",
  "confirm": "Confirm",
  "deny": "Deny",
  "searchTitleOrRequester": "Search title or requester...",
  "searchRequests": "Search requests",
  "allStatuses": "All statuses",
  "filterByStatus": "Filter by status",
  "moviesAndTV": "Movies and TV",
  "movies": "Movies",
  "tV": "TV",
  "filterByMediaType": "Filter by media type",
  "allRequestManagers": "All request managers",
  "filterByRequestManager": "Filter by request manager",
  "everyone": "Everyone",
  "filterByRequester": "Filter by requester",
  "clearAllFilters": "Clear all filters",
  "shelves": "Shelves",
  "grid": "Grid",
  "requestViewMode": "Request view mode",
  "mostSignificantRequest": "Most significant request",
  "requestedBy": "Requested by",
  "theRequestManagerStoresNoTitleAgainstThisRequest": "The request manager stores no title against this request, so it is shown by its external id.",
  "downloading": "Downloading.",
  "details": "Details",
  "eP": "EP",
  "title": "Title",
  "airDate": "Air date",
  "state": "State",
  "untitled": "Untitled",
  "inLibrary": "In library",
  "season": "Season",
  "episodes": "Episodes",
  "requested": "Requested",
  "noEpisodesReportedForThisSeason": "No episodes reported for this season.",
  "seasons": "Seasons",
  "episodeDetailNeedsAConnectedMediaServer": "Episode detail needs a connected media server.",
  "connectOneInStreamingSettings": "Connect one in Streaming settings",
  "mediaRequestsSettings": "Media Requests settings",
  "approved": "Approved",
  "partial": "Partial",
  "denied": "Denied",
  "failed": "Failed",
  "available2": "Available",
  "fulfilled": "Fulfilled",
  "unknown": "Unknown",
  "movie": "Movie",
  "requestedTitles": "Requested titles",
  "viewAll": "View all",
  "refresh": "Refresh",
  "retry": "Retry",
  "clearTheFiltersToSeeEverythingThatHasBeen": "Clear the filters to see everything that has been requested.",
  "someRequestManagersCouldNotBeReadSoTheir": "Some request managers could not be read, so their requests are missing from this list. See the notice above.",
  "thisShowsRequestsFromTheSeerrAndOmbiInstances": "This shows requests from the Seerr and Ombi instances on this server.",
  "showMoreInLibrary": "Show more in library",
  "connections": "connections",
  "gamingAndroid": "Gaming & Android",
  "consoleAppleWindows": "Console, Apple & Windows",
  "amazonLinux": "Amazon & Linux",
  "browsersSBC": "Browsers & SBC",
  "unknownInactive": "Unknown / Inactive",
  "unrecognizedOrInactiveDevices": "Unrecognized or inactive devices",
  "legend": "Legend:",
  "owner": "Owner:",
  "accountWideRemoval": "Account-wide removal",
  "plexRemovesTheDeviceFromYourEntirePlexAccount": "Plex removes the device from your entire Plex account, not just this server. Plex treats device removal as an advanced, unsupported operation.",
  "accountWide": "Account-wide",
  "removeThisDeviceFromTheMediaServer": "Remove this device from the media server",
  "remove": "Remove",
  "cannotResolveTheOwningUserForThisDeviceRefresh": "Cannot resolve the owning user for this device — refresh the device list",
  "noOwner": "No owner",
  "removeDeviceAccountWide": "Remove device account-wide?",
  "removeDeviceFromServer": "Remove device from server?",
  "removeFromServer": "Remove from server",
  "deviceRemovedFromTheMediaServer": "Device removed from the media server",
  "failedToRemoveDevice": "Failed to remove device",
  "staleDeviceReview": "Stale Device Review",
  "findDevicesInactivePastAThresholdAndRemoveTheir": "Find devices inactive past a threshold and remove their registration from the media server. Devices in an active session are never listed.",
  "inactivityThreshold": "Inactivity threshold",
  "inactiveFor": "Inactive for:",
  "days": "days",
  "scanForStaleDevices": "Scan for stale devices",
  "rescan": "Rescan",
  "scan": "Scan",
  "scanning": "Scanning...",
  "includeAllowedLibrariesInTemplate": "Include allowed libraries in template",
  "allowedLibraries": "Allowed Libraries",
  "includeExcludedSubFoldersInTemplate": "Include excluded sub-folders in template",
  "excludedSubFolders": "Excluded Sub-Folders",
  "checkAFieldAboveToConfigureLibraryAccessFor": "Check a field above to configure library access for this template",
  "templateNameIsRequired": "Template name is required",
  "templateUpdated": "Template updated",
  "templateCreated": "Template created",
  "failedToSaveTemplate": "Failed to save template",
  "newTemplate": "New Template",
  "cancel": "Cancel",
  "update": "Update",
  "create": "Create",
  "templateName": "Template Name",
  "serverType": "Server Type",
  "bothEmbyJellyfin": "Both (Emby + Jellyfin)",
  "embyOnly": "Emby Only",
  "jellyfinOnly": "Jellyfin Only",
  "setAsDefaultTemplate": "Set as default template",
  "default": "Default",
  "description": "Description",
  "briefDescriptionOfThisTemplate": "Brief description of this template...",
  "dismissHint": "Dismiss hint",
  "howTemplateFieldsWork": "How template fields work",
  "checkbox": "checkbox",
  "unincludedFieldsAreSkippedOnApplyExistingUserSettings": "Unincluded fields are skipped on apply (existing user settings preserved)",
  "overview": "Overview",
  "controls": "Controls",
  "devices": "Devices",
  "history": "History",
  "templates": "Templates",
  "stopAllActiveSessions": "Stop all active sessions",
  "stopAll": "Stop all",
  "failedToStopSessions": "Failed to stop sessions",
  "loadingUserProfile": "Loading user profile...",
  "failedToLoadUserProfile": "Failed to load user profile",
  "admin": "Admin",
  "disabled": "Disabled",
  "hidden": "Hidden",
  "noRecentActivity": "No recent activity",
  "lastActive": "Last active:",
  "stopAll2": "Stop All",
  "never": "Never",
  "justNow": "Just now",
  "serverUsers": "Server Users",
  "searchUsers": "Search users...",
  "loading": "Loading...",
  "loadingServerUsers": "Loading server users...",
  "failedToLoadUsers": "Failed to load users",
  "noUsersMatchYourSearch": "No users match your search",
  "noUsersFoundOnConfiguredServers": "No users found on configured servers",
  "availableInUserDetail": "Available in User Detail",
  "availableInSessionActions": "Available in Session Actions",
  "availableInEvidencePanel": "Available in evidence panel",
  "noIntentsRegisteredForThisDomain": "No intents registered for this domain.",
  "intentInventory": "Intent Inventory",
  "live": "live",
  "readOnly": "Read-Only",
  "safeWrites": "Safe Writes",
  "advancedOps": "Advanced Ops",
  "opensPanel": "Opens panel",
  "userContextRequired": "User context required",
  "sessionContextRequired": "Session context required",
  "complexFormRequired": "Complex form required",
  "locked": "Locked",
  "embySupported": "Emby supported",
  "e": "E",
  "jellyfinSupported": "Jellyfin supported",
  "j": "J",
  "plexSupported": "Plex supported",
  "p": "P",
  "healthEndpoint": "Health endpoint",
  "serverStorageInfo": "Server storage info",
  "prometheusMetrics": "Prometheus metrics",
  "encodingCodecInfo": "Encoding codec info",
  "fFmpegOptions": "FFmpeg options",
  "releaseNotesAPI": "Release notes API",
  "activityLog": "Activity log",
  "userManagement": "User management",
  "sessionControl": "Session control",
  "libraryScanTrigger": "Library scan trigger",
  "scheduledTasks": "Scheduled tasks",
  "pluginManagement": "Plugin management",
  "pluginEnableDisable": "Plugin enable/disable",
  "quickConnect": "QuickConnect",
  "backupCreate": "Backup create",
  "stopActiveTranscode": "Stop active transcode",
  "sessionPlayQueue": "Session play queue",
  "physicalPathsAPI": "Physical paths API",
  "serverCapabilitySnapshot": "Server Capability Snapshot",
  "capability": "Capability",
  "emby": "Emby (",
  "jellyfin": "Jellyfin (",
  "plex": "Plex (",
  "supported": "Supported",
  "live2": "Live",
  "connecting": "Connecting",
  "reconnecting": "Reconnecting",
  "breadcrumb": "Breadcrumb",
  "streamingDashboard": "Streaming Dashboard",
  "controlCenter": "Control Center",
  "slow": "Slow",
  "sessions": "Sessions",
  "users2": "Users",
  "liveIntents": "Live Intents",
  "browseServerUsers": "Browse server users",
  "capabilities": "Capabilities",
  "noConfigurationDataReturned": "No configuration data returned",
  "failedToLoadConfiguration": "Failed to load configuration",
  "saveConfiguration": "Save Configuration",
  "saveChanges": "Save Changes",
  "configurationSaved": "Configuration saved",
  "close": "Close",
  "loadingConfiguration": "Loading configuration",
  "filterKeys": "Filter keys...",
  "filterConfigurationKeys": "Filter configuration keys",
  "noMatchingKeys": "No matching keys",
  "noConfigurationEntries": "No configuration entries",
  "historyAnalytics": "History & Analytics",
  "mediaPortal": "Media Portal",
  "requests": "Requests",
  "wSDashboardIsNotEnabled": "WSDashboard is not enabled",
  "featureNotEnabled": "Feature Not Enabled",
  "theControlCenterRequiresWSDashboardToBeEnabled": "The Control Center requires WSDashboard to be enabled.",
  "generalSettingsFeatureFlags": "General Settings → Feature Flags",
  "loadingConfiguration2": "Loading configuration...",
  "noMediaServersConfigured": "No media servers configured",
  "configureYourMediaServers": "Configure Your Media Servers",
  "connectYourEmbyJellyfinOrPlexServerInThe": "Connect your Emby, Jellyfin, or Plex server in the Streaming Dashboard settings to populate the Control Center.",
  "manageAndMonitorYourMediaServers": "Manage and monitor your media servers.",
  "controlCenterSections": "Control Center sections",
  "active": "active",
  "failedToLoadPackages": "Failed to load packages",
  "noPackagesAvailable": "No packages available",
  "networkError": "Network error",
  "installPlugin": "Install Plugin",
  "install": "Install",
  "installFailed": "Install Failed",
  "loadingPackages": "Loading packages",
  "searchPackages": "Search packages...",
  "filterPackages": "Filter packages",
  "availablePackages": "Available packages",
  "noMatchingPackages": "No matching packages",
  "version": "Version:",
  "selectVersion": "Select version",
  "configured": "Configured",
  "notConfigured": "Not configured",
  "tVShows": "TV Shows",
  "music": "Music",
  "mixedContent": "Mixed Content",
  "homeVideos": "Home Videos",
  "books": "Books",
  "pathAlreadyAdded": "Path already added",
  "libraryNameIsRequired": "Library name is required",
  "atLeastOnePathIsRequired": "At least one path is required",
  "createLibrary": "Create Library",
  "areYouSureThisWillCreateANewLibrary": "Are you sure? This will create a new library on the server.",
  "libraryCreated": "Library created",
  "addLibrary": "Add Library",
  "closeDialog": "Close dialog",
  "libraryName": "Library Name",
  "collectionType": "Collection Type",
  "mediaPaths": "Media Paths",
  "addPath": "Add path",
  "add": "Add",
  "refreshLibraryAfterCreation": "Refresh library after creation",
  "creating": "Creating...",
  "mediaPathIsRequired": "Media path is required",
  "addMediaPath": "Add Media Path",
  "addThisPathToTheLibrary": "Add this path to the library?",
  "addPath2": "Add Path",
  "mediaPathAdded": "Media path added",
  "nameOfTheExistingLibraryToAddThePath": "Name of the existing library to add the path to",
  "mediaPath": "Media Path",
  "filesystemPathToAdd": "Filesystem path to add",
  "refreshLibraryAfterAddingPath": "Refresh library after adding path",
  "adding": "Adding...",
  "fullLibraryScan": "Full Library Scan",
  "triggerAFullLibraryScanOnAllConfiguredServers": "Trigger a full library scan on all configured servers. This may take several minutes depending on library size.",
  "libraryScanTriggered": "Library Scan Triggered",
  "theScanHasBeenQueuedOnAllConfiguredServers": "The scan has been queued on all configured servers.",
  "scanFailed": "Scan Failed",
  "deleteLibraryItems": "Delete Library Items",
  "typeDELETEToConfirm": "Type DELETE to confirm",
  "deleteSelected": "Delete Selected",
  "confirmationFailed": "Confirmation Failed",
  "itemsDeleted": "Items Deleted",
  "deleteFailed": "Delete Failed",
  "refreshMetadata": "Refresh Metadata",
  "metadataRefreshed": "Metadata Refreshed",
  "partialRefresh": "Partial Refresh",
  "refreshFailed": "Refresh Failed",
  "noMediaServerConfigured": "No media server configured",
  "contentOverview": "Content Overview",
  "artists": "Artists",
  "albums": "Albums",
  "songs": "Songs",
  "loadingLibraryCounts": "Loading library counts...",
  "contentSearch": "Content Search",
  "searchAcrossAllLibraries": "Search across all libraries",
  "searchContentAcrossAllLibraries": "Search content across all libraries",
  "clearSearch": "Clear search",
  "cancelSelection": "Cancel selection",
  "selectItemsForBulkActions": "Select items for bulk actions",
  "select": "Select",
  "refreshing": "Refreshing...",
  "deleting": "Deleting...",
  "noResultsFound": "No results found",
  "recentlyAdded": "Recently Added",
  "physicalPaths": "Physical Paths",
  "noPathsData": "No paths data",
  "watchAnalytics": "Watch Analytics",
  "libraryScanInProgress": "Library scan in progress",
  "scanLibrary": "Scan library",
  "scanLibrary2": "Scan Library",
  "addLibrary2": "Add library",
  "addMediaPath2": "Add media path",
  "deviceSummary": "Device Summary",
  "loadingDevices": "Loading devices...",
  "total": "Total",
  "active2": "Active",
  "stale": "Stale",
  "noDeviceDataAvailable": "No device data available",
  "platforms": "Platforms",
  "byServer": "By Server",
  "geoIPCache": "GeoIP Cache",
  "memoryCache": "Memory Cache",
  "dBRecords": "DB Records",
  "successRate": "Success Rate",
  "rateLimited": "Rate Limited",
  "yes": "Yes",
  "no": "No",
  "openDeviceManagement": "Open Device Management",
  "searchNameIsRequired": "Search name is required",
  "yearMustBeBetween1800And2200": "Year must be between 1800 and 2200",
  "theServerIsRePullingMetadataChangesAppearShortly": "The server is re-pulling metadata — changes appear shortly.",
  "applyMatchFailed": "Apply match failed",
  "confirmMatch": "Confirm Match",
  "replaceAllImagesWithTheNewMatchSArtwork": "Replace all images with the new match's artwork",
  "back": "Back",
  "applying": "Applying...",
  "applyMatch": "Apply Match",
  "searchName": "Search Name",
  "titleToSearchFor": "Title to search for",
  "year": "Year",
  "any": "Any",
  "search": "Search",
  "searchingMetadataProviders": "Searching metadata providers...",
  "noMatchesFoundTryAdjustingTheNameOrYear": "No matches found. Try adjusting the name or year.",
  "matchCandidates": "Match candidates",
  "libraryMaintenance": "Library Maintenance",
  "loadingLibraryStatus": "Loading library status...",
  "refreshLibraryStatus": "Refresh library status",
  "scanning2": "Scanning",
  "messagingConfiguration": "Messaging Configuration",
  "defaultSubject": "Default Subject",
  "defaultTemplate": "Default Template",
  "instanceName": "Instance Name",
  "wSDConfiguration": "WSD Configuration",
  "dashboardEnabled": "Dashboard Enabled",
  "geoIPEnrichment": "GeoIP Enrichment",
  "enabled": "Enabled",
  "pollInterval": "Poll Interval",
  "pauseRuleEnforcement": "Pause Rule Enforcement",
  "status": "Status",
  "liveTV": "Live TV",
  "scheduledTasks2": "Scheduled Tasks",
  "loadingScheduledTasks": "Loading scheduled tasks...",
  "noServersConfigured": "No servers configured",
  "refreshScheduledTasks": "Refresh scheduled tasks",
  "installedPlugins": "Installed Plugins",
  "loadingPlugins": "Loading plugins...",
  "noPluginsInstalled": "No plugins installed",
  "serverConfiguration": "Server Configuration",
  "loadingServerConfiguration": "Loading server configuration...",
  "wSDSettings": "WSD Settings",
  "notificationSettings": "Notification Settings",
  "running": "running",
  "failed2": "failed",
  "showLess": "Show less",
  "runScheduledTask": "Run Scheduled Task",
  "runTask": "Run Task",
  "stopRunningTask": "Stop Running Task",
  "stopTask": "Stop Task",
  "running2": "Running",
  "cancelling": "Cancelling",
  "idle": "Idle",
  "stopThisTask": "Stop this task",
  "runThisTaskNow": "Run this task now",
  "processing": "Processing",
  "disablePlugin": "Disable Plugin",
  "failedToLoadPluginConfig": "Failed to load plugin config",
  "noServerDataReturned": "No server data returned",
  "editPluginConfiguration": "Edit plugin configuration",
  "disablePlugin2": "Disable plugin",
  "enablePlugin": "Enable plugin",
  "editPluginConfigurationValuesComplexValuesObjectsArraysAre": "Edit plugin configuration values. Complex values (objects, arrays) are read-only.",
  "failedToLoadSection": "Failed to load section",
  "noSectionSelected": "No section selected",
  "editAConfigurationSection": "Edit a configuration section:",
  "customSectionName": "Custom section name...",
  "configurationSectionName": "Configuration section name",
  "edit": "Edit",
  "editConfigurationValuesForThisSectionComplexValuesObjects": "Edit configuration values for this section. Complex values (objects, arrays) are read-only.",
  "directoryTree": "Directory tree",
  "bluRay": "Blu-ray",
  "dVD": "DVD",
  "standardMetadataRefresh": "Standard metadata refresh",
  "refreshImages": "Refresh Images",
  "reDownloadAllImages": "Re-download all images",
  "none": "None",
  "fullRefresh2": "Full Refresh",
  "fullMetadataAndImageRefresh": "Full metadata and image refresh",
  "forceOverwrite": "Force Overwrite",
  "replaceAllMetadataAndImagesDestructive": "Replace all metadata and images (destructive)",
  "episode": "Episode",
  "sD": "SD",
  "reAnalyzeMediaFile": "Re-analyze Media File",
  "reAnalyze": "Re-analyze",
  "reAnalyzeFailed": "Re-analyze failed",
  "refreshOptions": "Refresh Options",
  "matchAnalysis": "Match & Analysis",
  "identifySearchProvidersAndRematchThisItem": "Identify: search providers and rematch this item",
  "identify": "Identify",
  "searchProvidersAndPickTheCorrectMatch": "Search providers and pick the correct match",
  "reAnalyzeReProbeMediaFileProperties": "Re-analyze: re-probe media file properties",
  "dP": "DP",
  "dS": "DS",
  "tC": "TC",
  "stop": "Stop",
  "thisWillDisconnectTheirDevice": "This will disconnect their device.",
  "killSession": "Kill Session",
  "enterMessage": "Enter message...",
  "send": "Send",
  "paused": "Paused",
  "resume": "Resume",
  "pause": "Pause",
  "killSession2": "Kill session",
  "sendMessage": "Send message",
  "sessionOverview": "Session Overview",
  "uniqueUsers": "Unique Users",
  "playMethod": "Play Method",
  "directPlay": "Direct Play",
  "directStream": "Direct Stream",
  "transcoding": "Transcoding",
  "byMediaType": "By Media Type",
  "topWatchers": "Top Watchers",
  "stream": "Stream",
  "byDevice": "By Device",
  "liveSessions": "Live Sessions",
  "pauseRules": "Pause Rules",
  "notice": "Notice:",
  "transcodeCache": "Transcode Cache",
  "purgeActive": "Purge Active",
  "purgeDisabled": "Purge Disabled",
  "files": "Files",
  "totalSize": "Total Size",
  "standard": "Standard",
  "noActiveSessions": "No active sessions",
  "viewLiveDashboard": "View Live Dashboard",
  "justNow2": "just now",
  "wSDConnection": "WSD Connection",
  "serverResponseSlow": "Server response slow",
  "configuredServers": "Configured Servers",
  "serverHealth": "Server Health",
  "checkingServerHealth": "Checking server health...",
  "noServersToCheck": "No servers to check",
  "reCheckServerHealth": "Re-check server health",
  "reCheck": "Re-check",
  "recentActivity": "Recent Activity",
  "loadingActivityLog": "Loading activity log...",
  "noActivityData": "No activity data",
  "encodingCapabilities": "Encoding Capabilities",
  "releaseNotes": "Release Notes",
  "quickAccess": "Quick Access",
  "wSDActivityLogs": "WSD Activity Logs",
  "healthy": "Healthy",
  "unhealthy": "Unhealthy",
  "serverUpdates": "Server Updates",
  "updateAvailable": "Update Available",
  "upToDate": "Up to date",
  "info": "Info",
  "noStorageData": "No storage data",
  "serverLogFiles": "Server Log Files",
  "noLogFiles": "No log files",
  "showFewerLogFiles": "Show fewer log files",
  "showAllLogFiles": "Show all log files",
  "noEncodingDataAvailable": "No encoding data available",
  "beta": "Beta",
  "noChangelogAvailable": "No changelog available",
  "viewOnGitHub": "View on GitHub",
  "noReleaseNotesAvailable": "No release notes available",
  "userSummary": "User Summary",
  "loadingUsers": "Loading users...",
  "totalUsers": "Total Users",
  "activeNow": "Active Now",
  "admins": "Admins",
  "noUserDataAvailable": "No user data available",
  "currentlyStreaming": "Currently Streaming",
  "openServerUsers": "Open Server Users",
  "createAPIKey": "Create API Key",
  "enterTheApplicationNameForThisAPIKey": "Enter the application name for this API key.",
  "applicationName": "Application Name",
  "createKey": "Create Key",
  "aPIKeyCreated": "API Key Created",
  "failedToCreateKey": "Failed to Create Key",
  "revokeAPIKey": "Revoke API Key",
  "revokeKey": "Revoke Key",
  "failedToRevokeKey": "Failed to Revoke Key",
  "aPIKeys": "API Keys",
  "loadingAPIKeys": "Loading API keys...",
  "createNewAPIKey": "Create new API key",
  "allTime": "All time",
  "shows": "Shows",
  "audio": "Audio",
  "couldnTSaveFilterPreference": "Couldn't save filter preference",
  "topWatched": "Top Watched",
  "mediaTypeFilter": "Media type filter",
  "all": "All",
  "timeWindow": "Time window",
  "noItemsMatchTheCurrentMediaTypeFilter": "No items match the current media type filter",
  "showAllTypes": "Show all types",
  "noDataForThisPeriod": "No data for this period",
  "yesterday": "Yesterday",
  "topUsers": "Top Users",
  "noPlaybackDataYet": "No playback data yet",
  "item": "item",
  "allServers": "All Servers",
  "watchHistory": "Watch History",
  "refreshHistory": "Refresh history",
  "filterByServer": "Filter by server",
  "startDate": "Start date",
  "endDate": "End date",
  "filterByTheDateASessionWasViewed": "Filter by the date a session was viewed.",
  "eitherFieldIsOptionalEmptyStartBeginningOfRecorded": "Either field is optional. Empty start = beginning of recorded history; empty end = now.",
  "withADateRangeActiveUpTo5000": "With a date range active, up to 5,000 matching entries load at once (paginated below). Without one, the most recent 100 entries are shown.",
  "dateRangeInfo": "Date range info",
  "clearDateRange": "Clear date range",
  "clear": "Clear",
  "searchTitleUserDevice": "Search title, user, device...",
  "noPlaybackHistoryYet": "No playback history yet",
  "historyIsRecordedAutomaticallyAsStreamingSessionsComplete": "History is recorded automatically as streaming sessions complete.",
  "user": "User",
  "allUsers": "All users",
  "server": "Server",
  "allServers2": "All servers",
  "device": "Device",
  "allDevices": "All devices",
  "watched": "Watched",
  "date": "Date",
  "statusHealth": "Status & Health",
  "serverIdentityVersionUptimeAPIConnectivityEncodingCapabilities": "Server identity, version, uptime, API connectivity, encoding capabilities",
  "usersAccess": "Users & Access",
  "userManagementPolicyControlsAuthenticationDeviceGovernance": "User management, policy controls, authentication, device governance",
  "sessionsPlayback": "Sessions & Playback",
  "liveSessionsPlaybackControlsTranscodingMessaging": "Live sessions, playback controls, transcoding, messaging",
  "contentLibraries": "Content & Libraries",
  "libraryInventoryScanControlsMetadataContentBrowsing": "Library inventory, scan controls, metadata, content browsing",
  "devicesConnectivity": "Devices & Connectivity",
  "deviceLifecyclePlatformBreakdownConnectionTracking": "Device lifecycle, platform breakdown, connection tracking",
  "notificationsAutomation": "Notifications & Automation",
  "notificationSettingsPauseRulesScheduledTasksAutomation": "Notification settings, pause rules, scheduled tasks, automation",
  "viewServerIdentityVersion": "View server identity & version",
  "viewPublicServerInfo": "View public server info",
  "healthCheckPing": "Health check / ping",
  "viewServerStorageCapacity": "View server storage capacity",
  "viewActivityLog": "View activity log",
  "viewServerLogFiles": "View server log files",
  "viewEncodingCapabilities": "View encoding capabilities",
  "viewFFmpegTranscodingOptions": "View FFmpeg/transcoding options",
  "viewTranscodeTempPath": "View transcode temp path",
  "restartServer": "Restart server",
  "shutdownServer": "Shutdown server",
  "viewReleaseNotesUpdates": "View release notes / updates",
  "viewWSDConnectionStatus": "View WSD connection status",
  "updateServer": "Update server",
  "listAllServerUsers": "List all server users",
  "viewUserProfileStats": "View user profile & stats",
  "viewUserAvatar": "View user avatar",
  "viewUserWatchHistory": "View user watch history",
  "viewUserWSDEnforcementPolicy": "View user WSD enforcement policy",
  "viewUserDevices": "View user devices",
  "disableEnableUserAccount": "Disable/enable user account",
  "hideUnhideUser": "Hide/unhide user",
  "toggleRemoteAccess": "Toggle remote access",
  "setSimultaneousStreamLimit": "Set simultaneous stream limit",
  "setRemoteBitrateLimit": "Set remote bitrate limit",
  "setMaxParentalRating": "Set max parental rating",
  "toggleMediaPlayback": "Toggle media playback",
  "toggleVideoTranscoding": "Toggle video transcoding",
  "toggleAudioTranscoding": "Toggle audio transcoding",
  "toggleSyncTranscoding": "Toggle sync transcoding",
  "toggleContentDeletion": "Toggle content deletion",
  "toggleContentDownloading": "Toggle content downloading",
  "setBypassKillStream": "Set bypass kill stream",
  "stopAllUserSessions": "Stop all user sessions",
  "createNewUser": "Create new user",
  "deleteUser": "Delete user",
  "resetUserPassword": "Reset user password",
  "viewUserLibraryAccess": "View user library access",
  "manageAPIKeys": "Manage API keys",
  "viewLoginActivityForUser": "View login activity for user",
  "listAllLibraries": "List all libraries",
  "viewLibraryItemCounts": "View library item counts",
  "viewRecentlyAddedItems": "View recently added items",
  "viewNewestReleases": "View newest releases",
  "viewItemMetadataDetails": "View item metadata details",
  "viewItemAncestors": "View item ancestors",
  "triggerFullLibraryScan": "Trigger full library scan",
  "refreshSingleItemMetadata": "Refresh single item metadata",
  "searchItemsAcrossLibraries": "Search items across libraries",
  "viewPhysicalPaths": "View physical paths",
  "viewItemExternalIDs": "View item external IDs",
  "addRemoveLibrary": "Add/remove library",
  "addRemoveMediaPaths": "Add/remove media paths",
  "deleteItemsFromLibrary": "Delete items from library",
  "viewMediaIntelligence": "View media intelligence",
  "triggerPerLibraryScan": "Trigger per-library scan",
  "refreshItemImagesArtwork": "Refresh item images/artwork",
  "identifyRematchMediaItem": "Identify / rematch media item",
  "reAnalyzeMediaFile2": "Re-analyze media file",
  "forceMetadataOverwrite": "Force metadata overwrite",
  "viewLibraryScanStatusTimestamps": "View library scan status & timestamps",
  "viewAllActiveSessions": "View all active sessions",
  "viewSessionStatistics": "View session statistics",
  "stopSessionPlayback": "Stop session playback",
  "killDisconnectSession": "Kill/disconnect session",
  "pauseSessionPlayback": "Pause session playback",
  "resumeSessionPlayback": "Resume session playback",
  "sendMessageToSession": "Send message to session",
  "broadcastMessageToAll": "Broadcast message to all",
  "viewGeoIPForSession": "View GeoIP for session",
  "viewWSDActionLogs": "View WSD action logs",
  "seekToPosition": "Seek to position",
  "skipToNextPreviousTrack": "Skip to next/previous track",
  "sendSystemCommand": "Send system command",
  "viewTranscodePurgeStats": "View transcode purge stats",
  "viewSessionPlayQueue": "View session play queue",
  "pauseRuleAutomation": "Pause rule automation",
  "geoLockEnforcement": "Geo-lock enforcement",
  "viewAllTrackedDevices": "View all tracked devices",
  "viewDeviceStats": "View device stats",
  "renameDevice": "Rename device",
  "deleteDeviceRecord": "Delete device record",
  "viewDeviceNameHistory": "View device name history",
  "viewDeviceIPHistory": "View device IP history",
  "viewGeoIPCacheStats": "View GeoIP cache stats",
  "viewWSDSettings": "View WSD settings",
  "updateWSDSettings": "Update WSD settings",
  "testUpstreamConnection": "Test upstream connection",
  "viewNotificationSettings": "View notification settings",
  "updateNotificationSettings": "Update notification settings",
  "viewUpstreamServerConfig": "View upstream server config",
  "viewNamedConfigSection": "View named config section",
  "updateServerConfiguration": "Update server configuration",
  "listInstalledPlugins": "List installed plugins",
  "viewPluginConfiguration": "View plugin configuration",
  "updatePluginConfiguration": "Update plugin configuration",
  "enableDisablePlugin": "Enable/disable plugin",
  "installUninstallPlugin": "Install/uninstall plugin",
  "viewAvailablePackages": "View available packages",
  "viewLiveTVSourcesTuners": "View Live TV sources/tuners",
  "manageLiveTVSourceLabels": "Manage Live TV source labels",
  "listScheduledTasks": "List scheduled tasks",
  "runAScheduledTask": "Run a scheduled task",
  "stopARunningTask": "Stop a running task",
  "purgeTranscodeCache": "Purge transcode cache",
  "alphabetNavigation": "Alphabet navigation",
  "backdrop": "Backdrop",
  "primary": "Primary",
  "continueWatchingShelf": "Continue Watching shelf",
  "continueWatching": "Continue Watching",
  "failedToLoadContinueWatching": "Failed to load continue watching",
  "adjustPosterSize": "Adjust poster size",
  "mediaPosterDensity": "Media poster density",
  "noWatchAnalyticsYet": "No watch analytics yet",
  "plays": "Plays",
  "views": "Views",
  "time": "Time",
  "quality": "Quality",
  "comp": "Comp",
  "plays2": "Plays:",
  "totalPlayTime": "Total Play Time:",
  "totalSeasonCompletion": "Total Season Completion:",
  "episodeBreakdown": "Episode Breakdown",
  "viewDetails": "View Details",
  "closeLibraries": "Close libraries",
  "browseLibraries": "Browse libraries",
  "scrollLibrariesLeft": "Scroll libraries left",
  "scrollLibrariesRightOrClose": "Scroll libraries right or close",
  "heroRotation": "Hero rotation",
  "transcode": "Transcode",
  "playbackMethods": "Playback Methods",
  "resolutionBreakdown": "Resolution Breakdown",
  "clientApps": "Client Apps",
  "qualityFirst": "Quality First",
  "playbackFirst": "Playback First",
  "deviceFirst": "Device First",
  "unknownQuality": "Unknown Quality",
  "historicalImport": "Historical Import",
  "otherClients": "Other Clients",
  "otherUsers": "Other Users",
  "client": "Client",
  "sankeyViewMode": "Sankey view mode",
  "deviceFlowNeedsVariedPlaybackData": "Device flow needs varied playback data",
  "morePlaybackSessionsWithDifferentDevicesOrQualityLevels": "More playback sessions with different devices or quality levels will populate this chart.",
  "playbackFlow": "Playback Flow",
  "noAnalyticsDataAvailableForThisItem": "No analytics data available for this item",
  "cast": "Cast",
  "castMembers": "Cast members",
  "noDeviceDataAvailableForThisItem": "No device data available for this item",
  "fitAllMarkers": "Fit all markers",
  "resetMapViewToFitAllMarkers": "Reset map view to fit all markers",
  "excellent": "Excellent",
  "good": "Good",
  "fair": "Fair",
  "low": "Low",
  "noGeographicDataAvailableForThisItem": "No geographic data available for this item",
  "viewerLocations": "Viewer Locations",
  "location": "location",
  "viewerGeoMap": "Viewer geo map",
  "viewers": "Viewers",
  "watchTime": "Watch Time",
  "completion": "Completion",
  "health": "Health",
  "trending": "Trending",
  "critic": "Critic",
  "locations": "Locations",
  "actions": "Actions",
  "copied": "Copied!",
  "copyItemID": "Copy Item ID",
  "watch": "Watch",
  "compl": "Compl.",
  "trend": "Trend",
  "locs": "Locs",
  "countries": "Countries",
  "castCrew": "Cast & Crew",
  "studios": "Studios",
  "dates": "Dates",
  "premiere": "Premiere",
  "dateAdded": "Date Added",
  "seriesInfo": "Series Info",
  "productionLocations": "Production Locations",
  "tags": "Tags",
  "externalLinks": "External Links",
  "libraryHierarchy": "Library Hierarchy",
  "dolbyVisionDynamicMetadataSceneBySceneOptimization12": "Dolby Vision -- Dynamic metadata, scene-by-scene optimization, 12-bit color depth",
  "hDR10DynamicMetadataWithSamsungSOpenStandard10": "HDR10+ -- Dynamic metadata with Samsung's open standard, 10-bit color depth",
  "hDR10StaticMetadata10BitColorDepthWideColor": "HDR10 -- Static metadata, 10-bit color depth, wide color gamut",
  "hLGHybridLogGammaBroadcastCompatibleHDRNoMetadata": "HLG (Hybrid Log-Gamma) -- Broadcast-compatible HDR, no metadata required",
  "h264AVCAdvancedVideoCodingWidelyCompatible": "H.264 / AVC -- Advanced Video Coding, widely compatible",
  "h265HEVCHighEfficiencyVideoCodingBetterCompression": "H.265 / HEVC -- High Efficiency Video Coding, better compression than H.264",
  "aV1RoyaltyFreeNextGenCodecExcellentCompression": "AV1 -- Royalty-free next-gen codec, excellent compression",
  "vP9GoogleSOpenCodecUsedInYouTubeAnd": "VP9 -- Google's open codec, used in YouTube and WebM",
  "mPEG4Part2LegacyCodecLowerEfficiency": "MPEG-4 Part 2 -- Legacy codec, lower efficiency",
  "vC1MicrosoftSVideoCodecUsedInBlu": "VC-1 -- Microsoft's video codec, used in Blu-ray",
  "video": "Video",
  "codec": "Codec",
  "resolution": "Resolution",
  "aspectRatio": "Aspect Ratio",
  "frameRate": "Frame Rate",
  "pixelFormat": "Pixel Format",
  "colorSpace": "Color Space",
  "bitrate": "Bitrate",
  "unlimitedBitrate": "∞ bitrate",
  "forced": "Forced",
  "external": "External",
  "bitmap": "Bitmap",
  "subtitles": "Subtitles",
  "versions": "Versions",
  "fileInfo": "File Info",
  "container": "Container",
  "fileSize": "File Size",
  "videoType": "Video Type",
  "chapters": "Chapters",
  "chapterTimeline": "Chapter timeline",
  "completedViewing": "Completed viewing",
  "completed": "Completed",
  "noViewerDataAvailableForThisItem": "No viewer data available for this item",
  "nameAZ": "Name A–Z",
  "nameZA": "Name Z–A",
  "topRated": "Top Rated",
  "releaseDate": "Release Date",
  "hD": "HD",
  "allGenres": "All Genres",
  "sortBy": "Sort by",
  "filterByGenre": "Filter by genre",
  "filterByResolution": "Filter by resolution",
  "scanRequested": "Scan requested…",
  "scanLibraryNowShiftClickOrRightClickFor": "Scan library now (Shift+click or right-click for deep scan)",
  "scanLibraryNow": "Scan library now",
  "failedToLoadLibraryItems": "Failed to load library items",
  "noItemsInThisLibrary": "No items in this library",
  "theMediaPortalRequiresWSDashboardToBeEnabled": "The Media Portal requires WSDashboard to be enabled.",
  "connectYourEmbyJellyfinOrPlexServerInThe2": "Connect your Emby, Jellyfin, or Plex server in the Streaming Dashboard settings.",
  "subtitlesAvailable": "Subtitles available",
  "unpinInfoOverlay": "Unpin info overlay",
  "pinInfoOverlay": "Pin info overlay",
  "failedToUpdateRating": "Failed to update rating",
  "failedToUpdateFavorite": "Failed to update favorite",
  "addedToFavorites": "Added to favorites",
  "removedFromFavorites": "Removed from favorites",
  "watchTime2": "Watch time",
  "averageCompletion": "Average completion",
  "recentlyAddedShelf": "Recently Added shelf",
  "scrollLeft": "Scroll left",
  "scrollRight": "Scroll right",
  "mKV": "MKV",
  "aVI": "AVI",
  "tS": "TS",
  "cC": "CC",
  "upcoming": "Upcoming",
  "imdb": "Imdb",
  "tmdb": "Tmdb",
  "tvdb": "Tvdb",
  "alwaysShow": "Always Show",
  "onlyForced": "Only Forced",
  "smart": "Smart",
  "showButton": "Show Button",
  "autoSkip": "Auto Skip",
  "accountStatus": "Account Status",
  "accountDisabled": "Account Disabled",
  "preventsTheUserFromSigningIn": "Prevents the user from signing in",
  "hiddenUser": "Hidden User",
  "hidesTheUserFromLoginScreensAndUserLists": "Hides the user from login screens and user lists",
  "hiddenRemotely": "Hidden Remotely",
  "hidesTheUserFromRemoteLoginScreens": "Hides the user from remote login screens",
  "hiddenFromNewDevices": "Hidden from New Devices",
  "hidesTheUserOnDevicesTheyHaveNotUsed": "Hides the user on devices they have not used before",
  "accessStreaming": "Access & Streaming",
  "remoteAccess": "Remote Access",
  "allowThisUserToConnectRemotely": "Allow this user to connect remotely",
  "mediaPlayback": "Media Playback",
  "allowMediaPlaybackOnTheServer": "Allow media playback on the server",
  "streamLimit": "Stream Limit",
  "maximumSimultaneousStreams0Unlimited": "Maximum simultaneous streams (0 = unlimited)",
  "bitrateLimit": "Bitrate Limit",
  "remoteClientBitrateLimit0Unlimited": "Remote client bitrate limit (0 = unlimited)",
  "playbackTranscoding": "Playback & Transcoding",
  "audioTranscoding": "Audio Transcoding",
  "allowAudioTranscodingDuringPlayback": "Allow audio transcoding during playback",
  "videoTranscoding": "Video Transcoding",
  "allowVideoTranscodingDuringPlayback": "Allow video transcoding during playback",
  "remuxing": "Remuxing",
  "allowContainerRemuxingDuringPlayback": "Allow container remuxing during playback",
  "syncTranscoding": "Sync Transcoding",
  "allowTranscodingForOfflineSync": "Allow transcoding for offline sync",
  "mediaConversion": "Media Conversion",
  "allowMediaFormatConversion": "Allow media format conversion",
  "autoRemoteQuality": "Auto Remote Quality",
  "automaticQualitySettingForRemotePlayback": "Automatic quality setting for remote playback",
  "libraryAccess": "Library Access",
  "accessAllLibraries": "Access All Libraries",
  "grantAccessToAllMediaLibraries": "Grant access to all media libraries",
  "specificLibraryNamesToAllowAccess": "Specific library names to allow access",
  "excludeSpecificMediaLocationsWithinLibrariesEG4K": "Exclude specific media locations within libraries (e.g., 4K folders)",
  "accessAllChannels": "Access All Channels",
  "grantAccessToAllChannels": "Grant access to all channels",
  "contentManagement": "Content Management",
  "allowDeletion": "Allow Deletion",
  "allowThisUserToDeleteContentFromTheServer": "Allow this user to delete content from the server",
  "allowDownloads": "Allow Downloads",
  "allowThisUserToDownloadContent": "Allow this user to download content",
  "subtitleDownloads": "Subtitle Downloads",
  "allowDownloadingExternalSubtitles": "Allow downloading external subtitles",
  "subtitleManagement": "Subtitle Management",
  "allowManagingSubtitlesOnTheServer": "Allow managing subtitles on the server",
  "parentalControls": "Parental Controls",
  "tagModeAllowlist": "Tag Mode: Allowlist",
  "useInclusiveTagBlockingMode": "Use inclusive tag blocking mode",
  "allowIfTagORRatingPasses": "Allow if Tag OR Rating passes",
  "allowContentIfEitherTagOrRatingCheckPasses": "Allow content if either tag or rating check passes",
  "maxRating": "Max Rating",
  "maximumAllowedParentalRating0None": "Maximum allowed parental rating (0 = none)",
  "blockedTags": "Blocked Tags",
  "tagsToBlockFromThisUser": "Tags to block from this user",
  "includeTags": "Include Tags",
  "tagsToIncludeForThisUser": "Tags to include for this user",
  "blockUnratedItems": "Block Unrated Items",
  "contentTypesToBlockWhenUnrated": "Content types to block when unrated",
  "socialSharing": "Social & Sharing",
  "publicSharing": "Public Sharing",
  "allowPublicMediaSharingLinks": "Allow public media sharing links",
  "sharePersonalItems": "Share Personal Items",
  "allowSharingPersonalMediaItems": "Allow sharing personal media items",
  "cameraUpload": "Camera Upload",
  "allowUploadingPhotosFromDeviceCamera": "Allow uploading photos from device camera",
  "liveTVAccess": "Live TV Access",
  "allowAccessToLiveTVStreams": "Allow access to live TV streams",
  "liveTVManagement": "Live TV Management",
  "allowManagingLiveTVSettings": "Allow managing live TV settings",
  "featuresControl": "Features & Control",
  "remoteControlOthers": "Remote Control Others",
  "allowRemoteControllingOtherUsersSessions": "Allow remote controlling other users' sessions",
  "sharedDeviceControl": "Shared Device Control",
  "allowControllingSharedDevices": "Allow controlling shared devices",
  "userPreferenceAccess": "User Preference Access",
  "allowAccessToUserPreferences": "Allow access to user preferences",
  "restrictedFeatures": "Restricted Features",
  "listOfRestrictedFeatureNames": "List of restricted feature names",
  "preferencesConfig": "Preferences (Config)",
  "audioLanguage": "Audio Language",
  "preferredAudioLanguageEGEngFre": "Preferred audio language (e.g. eng, fre)",
  "subtitleLanguage": "Subtitle Language",
  "preferredSubtitleLanguageEGEngFre": "Preferred subtitle language (e.g. eng, fre)",
  "subtitleMode": "Subtitle Mode",
  "defaultSubtitleDisplayMode": "Default subtitle display mode",
  "playDefaultAudio": "Play Default Audio",
  "playTheDefaultAudioTrackAutomatically": "Play the default audio track automatically",
  "showMissingEpisodes": "Show Missing Episodes",
  "showMissingEpisodesInSeriesViews": "Show missing episodes in series views",
  "autoPlayNext": "Auto-play Next",
  "automaticallyPlayTheNextEpisode": "Automatically play the next episode",
  "hidePlayedInLatest": "Hide Played in Latest",
  "hideAlreadyPlayedItemsFromLatestMedia": "Hide already-played items from latest media",
  "rememberAudio": "Remember Audio",
  "rememberAudioTrackSelectionsAcrossPlayback": "Remember audio track selections across playback",
  "rememberSubtitles": "Remember Subtitles",
  "rememberSubtitleSelectionsAcrossPlayback": "Remember subtitle selections across playback",
  "introSkip": "Intro Skip",
  "behaviorForSkippingIntros": "Behavior for skipping intros",
  "wSDEnforcement": "WSD Enforcement",
  "bypassKillStream": "Bypass Kill Stream",
  "exemptFromPauseWarningsAndAutomaticStops": "Exempt from pause warnings and automatic stops",
  "save": "Save",
  "whenEnabledThisUserWillNotReceivePauseWarnings": "When enabled, this user will not receive pause warnings or automatic stops.",
  "exceptionsTranscodingAndLiveTVSessionsAreAlwaysEnforced": "Exceptions: transcoding and Live TV sessions are always enforced.",
  "wSDLocalSettingDoesNotAffectUpstreamServer": "WSD-local setting, does not affect upstream server",
  "toggleBypassKillStream": "Toggle bypass kill stream",
  "bypassEnabledUserWillSkipPauseWarningsAndAuto": "Bypass enabled -- user will skip pause warnings and auto-stops",
  "bypassDisabledUserIsSubjectToEnforcementRules": "Bypass disabled -- user is subject to enforcement rules",
  "failedToUpdateBypassPolicy": "Failed to update bypass policy",
  "dangerZone": "Danger Zone",
  "thisUser": "this user",
  "resetPassword": "Reset Password",
  "deleteUser2": "Delete User",
  "customName": "Custom name...",
  "deviceIsLockedToThisAccount": "Device is locked to this account",
  "inactive": "Inactive",
  "lastSeen": "last seen",
  "deleteDeviceFromThisDashboard": "Delete device from this dashboard",
  "deviceRenamed": "Device renamed",
  "customNameCleared": "Custom name cleared",
  "failedToRenameDevice": "Failed to rename device",
  "deleteDevice": "Delete device?",
  "delete": "Delete",
  "deviceDeleted": "Device deleted",
  "lockDevice": "Lock device?",
  "unlockDevice": "Unlock device?",
  "lock": "Lock",
  "unlock": "Unlock",
  "deviceLocked": "Device locked",
  "deviceUnlocked": "Device unlocked",
  "failedToUpdateDeviceLock": "Failed to update device lock",
  "restrictToApprovedDevices": "Restrict to approved devices?",
  "restrict": "Restrict",
  "allDevicesEnabled": "All devices enabled",
  "switchedToDeviceWhitelist": "Switched to device whitelist",
  "failedToUpdateDeviceAccess": "Failed to update device access",
  "failedToLoadDevices": "Failed to load devices",
  "noDevicesRecorded": "No devices recorded",
  "devicesAppearAfterTheUserStreamsContent": "Devices appear after the user streams content",
  "allDevices2": "All Devices",
  "deviceWhitelist": "Device Whitelist",
  "thisUserCanStreamFromAnyDevice": "This user can stream from any device.",
  "onlyApprovedDevicesCanStreamLockDevicesBelowTo": "Only approved devices can stream. Lock devices below to add them to the whitelist.",
  "toggleAllDevicesAccess": "Toggle all devices access",
  "noData": "No data",
  "other": "Other",
  "historyTimeRange": "History time range",
  "avgCompletion": "Avg Completion",
  "byPlayMethod": "By Play Method",
  "recentPlays": "Recent Plays",
  "noWatchHistoryInThisPeriod": "No watch history in this period",
  "allLibraries": "All Libraries",
  "libraryAccess2": "Library access",
  "noLibrariesSelected": "No libraries selected",
  "excluded": "excluded",
  "libraryPicker": "Library picker",
  "searchLibraries": "Search libraries...",
  "searchLibraries2": "Search libraries",
  "allAccess": "all access",
  "noMatchingLibraries": "No matching libraries",
  "noLibrariesAvailable": "No libraries available",
  "expandLibrariesToManageSubFolderExclusions": "Expand libraries to manage sub-folder exclusions",
  "toggleLibrariesToControlAccess": "Toggle libraries to control access",
  "access": "Access",
  "sync": "Sync",
  "content": "Content",
  "deletion": "Deletion",
  "download": "Download",
  "uniqueTitles": "Unique Titles",
  "firstSeen": "First Seen",
  "upstreamPolicy": "Upstream Policy",
  "unlimited": "Unlimited",
  "topLibraries": "Top Libraries",
  "topGenres": "Top Genres",
  "policy": "policy",
  "config": "config",
  "wsd": "wsd",
  "editTemplate": "Edit template",
  "duplicateTemplate": "Duplicate template",
  "deleteTemplate": "Delete template",
  "applyTo": "Apply to",
  "templateName2": "Template name...",
  "descriptionOptional": "Description (optional)",
  "briefDescription": "Brief description...",
  "saveTemplate": "Save Template",
  "templateSavedFromUserSettings": "Template saved from user settings",
  "applyTemplate": "Apply Template",
  "failedToApplyTemplate": "Failed to apply template",
  "duplicateTemplate2": "Duplicate Template",
  "newTemplateName": "New template name...",
  "duplicate": "Duplicate",
  "templateDuplicated": "Template duplicated",
  "failedToDuplicateTemplate": "Failed to duplicate template",
  "deleteTemplate2": "Delete template?",
  "templateDeleted": "Template deleted",
  "failedToDeleteTemplate": "Failed to delete template",
  "saveAsTemplate": "Save as Template",
  "sSettings": "'s Settings",
  "capturesThisUserSCurrentPolicyAndConfigurationAs": "Captures this user's current policy and configuration as a reusable template for new users and device setups.",
  "createTemplate": "Create Template",
  "createFromScratch": "Create from Scratch",
  "buildATemplateFromScratchWithCustomPolicyAnd": "Build a template from scratch with custom policy and configuration values, independent of any existing user.",
  "loadingTemplates": "Loading templates...",
  "failedToLoadTemplates": "Failed to load templates",
  "noCompatibleTemplates": "No compatible templates",
  "saveAUserSSettingsAsATemplateTo": "Save a user's settings as a template to get started",
  "noPasswordSet": "No password set",
  "noPass": "No Pass",
  "activity": "Activity",
  "noActivity": "No activity",
  "lastWatched": "Last Watched",
  "location2": "Location",
  "lastActive2": "Last Active",
  "remoteAccessEnabled": "Remote access enabled",
  "remoteAccessDisabled": "Remote access disabled",
  "remoteAccessOn": "Remote access on",
  "remoteAccessOff": "Remote access off",
  "canDeleteContent": "Can delete content",
  "deletePermission": "Delete permission",
  "canDownloadContent": "Can download content",
  "downloadPermission": "Download permission",
  "limits": "Limits",
  "broadcastMessage": "Broadcast Message",
  "sendAPopupMessageToAllActiveSessionsOn": "Send a popup message to all active sessions on the server.",
  "enterMessageText": "Enter message text...",
  "broadcast": "Broadcast",
  "messageSent": "Message Sent",
  "broadcastDeliveredToAllSessions": "Broadcast delivered to all sessions.",
  "useTheRunStopButtonsInTheScheduledTasks": "Use the Run/Stop buttons in the Scheduled Tasks panel to select a specific task.",
  "success": "Success",
  "streamConnectionLostPollingForStatus": "Stream connection lost. Polling for status...",
  "dashboardIsRestartingStreamingContinuesViaRelay": "Dashboard is restarting — streaming continues via relay",
  "dashboardRestartCompleteFinishingPostUpdateWork": "Dashboard restart complete — finishing post-update work...",
  "couldNotReachTheServer": "Could not reach the server",
  "failedToLoadUserDevices": "Failed to load user devices",
  "failedToStopUserSessions": "Failed to stop user sessions",
  "failedToUpdateUserSettings": "Failed to update user settings",
  "failedToImportTemplateFromUser": "Failed to import template from user",
  "failedToCreateTemplate": "Failed to create template",
  "failedToUpdateTemplate": "Failed to update template",
  "failedToLoadWatchHistory": "Failed to load watch history",
  "failedToLoadUserStats": "Failed to load user stats",
  "failedToLoadTopItems": "Failed to load top items",
  "seerr": "Seerr",
  "ombi": "Ombi",
  "pending": "Pending",
  "aPIKeyUnreadable": "API key unreadable",
  "theAppIsInstalledButItsAPIKeyCould": "The app is installed but its API key could not be read. If the key was regenerated in the app's own settings, it should be picked up automatically; otherwise check the app's config file permissions.",
  "noPortRecorded": "No port recorded",
  "noPortIsRecordedForThisInstallSoThere": "No port is recorded for this install, so there is nothing to connect to. Reinstalling or updating the app re-records it.",
  "notResponding": "Not responding",
  "theAppIsInstalledButDidNotAnswerIt": "The app is installed but did not answer. It is most likely stopped.",
  "unusable": "Unusable",
  "theAppIsInstalledButCouldNotBeUsed": "The app is installed but could not be used, for a reason this version does not recognise.",
  "unknownRequester": "Unknown requester",
  "controlCenterDomains": "Control Center domains",
  "removeDeviceFromTheMediaServerUpstream": "Remove device from the media server (upstream)",
  "failedToDeleteDevice": "Failed to delete device",
  "failedToRemoveDeviceFromTheMediaServer": "Failed to remove device from the media server",
  "lockDevices": "Lock devices?",
  "deviceNamesSynced": "Device names synced",
  "failedToSyncDeviceNames": "Failed to sync device names",
  "wSDashboardIsNotEnabled2": "WSDashboard is not enabled.",
  "searchDevicesUsersIPs": "Search devices, users, IPs...",
  "showAllDevices": "Show all devices",
  "showActiveDevicesOnly": "Show active devices only",
  "showInactiveDevicesOnly": "Show inactive devices only",
  "showDevicesFromAllServers": "Show devices from all servers",
  "showEmbyDevicesOnly": "Show Emby devices only",
  "showJellyfinDevicesOnly": "Show Jellyfin devices only",
  "filterByPlatform": "Filter by platform",
  "allPlatforms": "All Platforms",
  "showAllPlatforms": "Show all platforms",
  "deselectAllDevices": "Deselect all devices",
  "selectAllDevices": "Select all devices",
  "deselectAll": "Deselect All",
  "selectAll": "Select All",
  "pushAllCustomDeviceNamesToEmbyJellyfin": "Push all custom device names to Emby/Jellyfin",
  "syncNames": "Sync Names",
  "reviewStaleDevicesForUpstreamRemoval": "Review stale devices for upstream removal",
  "reviewStale": "Review Stale",
  "refreshDeviceList": "Refresh device list",
  "lockSelected": "Lock Selected",
  "deviceManagement": "Device Management",
  "aboutDeviceManagement": "About device management",
  "deviceAccessControl": "Device Access Control",
  "lockingADeviceBindsItToTheUserS": "Locking a device binds it to the user's account. Once any device is locked, the user can only stream from their approved (locked) devices. New or unapproved devices will be blocked until an admin approves them.",
  "unlockingRemovesTheRestrictionIfAllDevicesAreUnlocked": "Unlocking removes the restriction. If all devices are unlocked, the user regains access to any device.",
  "browseAndManageDevicesAcrossYourMediaServers": "Browse and manage devices across your media servers.",
  "current": "Current",
  "archived": "Archived",
  "itemIDCopiedToClipboard": "Item ID copied to clipboard",
  "failedToCopyToClipboard": "Failed to copy to clipboard",
  "metadataRefreshTriggered": "Metadata refresh triggered",
  "failedToRefreshMetadata": "Failed to refresh metadata",
  "noTrailersAvailableForThisItem": "No trailers available for this item",
  "loadingItemDetails": "Loading item details...",
  "failedToLoadItemDetails": "Failed to load item details",
  "backToMedia": "Back to Media",
  "favorite": "Favorite",
  "xPlayed": "x played",
  "markAsUnwatched": "Mark as unwatched",
  "markAsWatched": "Mark as watched",
  "markWatched": "Mark Watched",
  "watchTrailer": "Watch Trailer",
  "closeQualityVersions": "Close quality versions",
  "showQualityVersions": "Show quality versions",
  "closeVersionsDock": "Close versions dock",
  "seasonBackdropRotation": "Season backdrop rotation",
  "noEpisodes": "No episodes",
  "versionAggregation": "Version aggregation",
  "allVersions": "All versions",
  "thisVersionOnly": "This version only",
  "noPlaysRecordedForThisFileVersion": "No plays recorded for this file version.",
  "technicalDetails": "Technical Details",
  "itemMetadataAndAnalytics": "Item metadata and analytics",
  "watchTrailer2": "Watch trailer",
  "closeTrailer": "Close trailer",
  "trailer": "Trailer",
  "sortedByPlays": "Sorted by plays",
  "sortedByWatchTime": "Sorted by watch time",
  "completion025": "Completion 0–25%",
  "completion2575": "Completion 25–75%",
  "completion75100": "Completion 75–100%",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "last90Days": "Last 90 days",
  "last180Days": "Last 180 days",
  "library": "Library",
  "backToMediaPortal": "Back to Media Portal",
  "libraryNotFound": "Library not found",
  "libraryNotFoundBody": "This library does not exist or is no longer available on a connected media server.",
  "analyticsView": "Analytics view",
  "exitAnalyticsView": "Exit analytics view",
  "noPlayedItemsMatchThisView": "No played items match this view",
  "noItemsMatchYourFilters": "No items match your filters",
  "failedToLoadLibraries": "Failed to load libraries",
  "noMediaLibrariesConfigured": "No media libraries configured",
  "thisRequestIsNoLongerThere": "This request is no longer there",
  "itMayHaveBeenDecidedOrRemovedInThe": "It may have been decided or removed in the request manager since this link was made.",
  "backToRequests": "Back to requests",
  "loadingRequest": "Loading request",
  "seasonsRequested": "Seasons requested",
  "requestManager": "Request manager",
  "type": "Type",
  "lastUpdated": "Last updated",
  "runtime": "Runtime",
  "rating": "Rating",
  "checkingTheCurrentState": "Checking the current state...",
  "inYourLibraryOpenIt": "In your library — open it",
  "thisHasLandedInTheLibrary": "This has landed in the library.",
  "thisRequestHasAlreadyBeenDecidedSoThereIs": "This request has already been decided, so there is nothing left to approve or deny.",
  "addAReasonForDenying": "Add a reason for denying",
  "couldNotConfirmThisRequestSCurrentState": "Could not confirm this request's current state.",
  "approveAndDenyAreUnavailableUntilItCanBe": "Approve and deny are unavailable until it can be read again.",
  "tryAgain": "Try again",
  "reasonForDenying": "Reason for denying",
  "optional": "Optional",
  "discard": "Discard",
  "mine": "Mine",
  "requestScope": "Request scope",
  "failedToCreateUser": "Failed to Create User",
  "createUser": "Create User",
  "refreshUserList": "Refresh user list",
  "browseAndManageUsersAcrossYourMediaServers": "Browse and manage users across your media servers.",
  "thisWillCreateARealUserOnTheMedia": "This will create a real user on the media server.",
  "username": "Username",
  "enterUsername": "Enter username",
  "password": "Password",
  "enterPasswordOptional": "Enter password (optional)",
  "leaveBlankToCreateTheUserWithoutAPassword": "Leave blank to create the user without a password.",
  "stopAllSessions": "Stop All Sessions",
  "typeUsernameToConfirm": "Type username to confirm",
  "usernameMismatch": "Username Mismatch",
  "failedToDeleteUser": "Failed to Delete User",
  "newPassword": "New password",
  "newPassword2": "New Password",
  "failedToResetPassword": "Failed to Reset Password",
  "userDetailTabs": "User detail tabs",
  "userStatusAndActions": "User status and actions",
  "liveStatus": "Live Status",
  "activeSessions2": "Active Sessions",
  "lastLogin": "Last Login",
  "backToServerUsers": "Back to Server Users",
  "dangerZoneActions": "Danger zone actions",
  "requestDeniedReasonDeniedReason": "Request denied. Reason: {{deniedReason}}",
  "textMediaTypeRequestNotALibraryItemRequestedViaProviderId": "{{text}}. {{mediaType}}. Request, not a library item. Requested via {{providerId}} by {{requester}}. {{percent}}",
  "downloadProgressComplete": "Download {{progress}}% complete",
  "requestedThroughLabel": "Requested through {{label}}",
  "textMediaTypeStatusRequestedByRequesterWhenOpenRequestDetails": "{{text}}. {{mediaType}}. {{status}}. Requested by {{requester}}{{when}}. Open request details.",
  "approveLabel": "Approve {{label}}",
  "pressAgainToDenyLabel": "Press again to deny {{label}}",
  "denyLabel": "Deny {{label}}",
  "confirmDenialOfLabel": "Confirm denial of {{label}}",
  "textDownloadProgress": "{{text}} download progress",
  "episodesInSeasonNumber": "Episodes in {{seasonNumber}}",
  "inLibraryAlreadyInYourLibrary": "{{inLibrary}} already in your library",
  "declinedDenied": "{{declined}} denied",
  "viewAllLength": "View all {{length}}",
  "completedTitle": "Completed: {{title}}",
  "inProgressTitle": "In progress: {{title}}",
  "filterByLabel": "Filter by {{label}}",
  "labelMap": "{{label}} map",
  "labelMapTiles": "{{label}} map tiles",
  "lastActiveToLocaleDateString": "last active {{toLocaleDateString}}",
  "removeDeviceNameFromTheMediaServer": "Remove {{deviceName}} from the media server",
  "labelValue": "{{label}} value",
  "selectLabel": "Select {{label}}...",
  "labelValues": "{{label}} values",
  "includeLabelInTemplate": "Include {{label}} in template",
  "editTemplateName": "Edit Template: {{name}}",
  "stopAllActiveSessionsForUserNameThisWillImmediatelyEnd": "Stop all active sessions for {{userName}}? This will immediately end their playback.",
  "userNameUserAdmin": "{{userName}} -- User Admin",
  "openAdminPanelForValue": "Open admin panel for {{value}}",
  "lengthOfLength2Users": "{{length}} of {{length2}} users",
  "statusWsdStatus": "Status: {{wsdStatus}}",
  "riskRisk": "{{risk}} risk",
  "saveFailedMessage": "Save failed: {{message}}",
  "lengthItems": "[{{length}} items]",
  "installNameVSelectedVersionAServerRestartMayBeRequired": "Install \"{{name}}\" v{{selectedVersion}}? A server restart may be required.",
  "installedNameVSelectedVersion": "Installed {{name}} v{{selectedVersion}}",
  "maximumValuePathsAllowed": "Maximum {{value}} paths allowed",
  "libraryNameMustBeValueCharactersOrFewer": "Library name must be {{value}} characters or fewer",
  "failedToCreateLibraryMessage": "Failed to create library: {{message}}",
  "removePathP": "Remove path {{p}}",
  "pathMustBeValueCharactersOrFewer": "Path must be {{value}} characters or fewer",
  "failedToAddPathMessage": "Failed to add path: {{message}}",
  "thisWillPermanentlyDeleteCountItemSFromTheLibrary": "This will permanently delete {{count}} item(s) from the library. Type DELETE to confirm.",
  "youTypedInputButDELETEWasRequiredActionCancelled": "You typed \"{{input}}\" but \"DELETE\" was required. Action cancelled.",
  "successfullyDeletedCountItemSFromTheLibrary": "Successfully deleted {{count}} item(s) from the library.",
  "thisWillRefreshMetadataForCountSelectedItemSFrom": "This will refresh metadata for {{count}} selected item(s) from the media server.",
  "successfullyQueuedMetadataRefreshForTotalSuccessItemS": "Successfully queued metadata refresh for {{totalSuccess}} item(s).",
  "refreshedTotalSuccessItemSTotalFailedFailed": "Refreshed {{totalSuccess}} item(s), {{totalFailed}} failed.",
  "failedToRefreshMetadataForTotalFailedItemS": "Failed to refresh metadata for {{totalFailed}} item(s).",
  "refreshMetadataForSizeSelectedItems": "Refresh metadata for {{size}} selected items",
  "deleteSizeSelectedItems": "Delete {{size}} selected items",
  "platformDeviceShare": "{{platform}} device share",
  "memoryCacheSizeIPs": "{{memoryCacheSize}} IPs",
  "matchAppliedToName": "Match applied to \"{{name}}\"",
  "identifyName": "Identify {{name}}",
  "identifyName2": "Identify \"{{name}}\"",
  "selectMatchNameYear": "Select match {{name}}{{year}}",
  "triggerAScanOfNameThisMayTakeSeveralMinutes": "Trigger a scan of \"{{name}}\"? This may take several minutes depending on library size.",
  "scanStartedForName": "Scan started for \"{{name}}\"",
  "scanFailedForName": "Scan failed for \"{{name}}\"",
  "scanningName": "Scanning {{name}}",
  "scanName": "Scan {{name}}",
  "moviesWarningSecondsWarnMoviesStopSecondsStop": "{{moviesWarningSeconds}} warn / {{moviesStopSeconds}} stop",
  "tvWarningSecondsWarnTvStopSecondsStop": "{{tvWarningSeconds}} warn / {{tvStopSeconds}} stop",
  "livetvWarningSecondsWarnLivetvStopSecondsStop": "{{livetvWarningSeconds}} warn / {{livetvStopSeconds}} stop",
  "showAllLengthTasks": "Show all {{length}} tasks",
  "runNameNow": "Run \"{{name}}\" now?",
  "stopNameTheTaskMayTakeAMomentToCancel": "Stop \"{{name}}\"? The task may take a moment to cancel.",
  "stopName": "Stop {{name}}",
  "runName": "Run {{name}}",
  "showAllLengthPlugins": "Show all {{length}} plugins",
  "disablingNameMayAffectServerFunctionalityContinue": "Disabling \"{{name}}\" may affect server functionality. Continue?",
  "editNameConfiguration": "Edit {{name}} configuration",
  "disableName": "Disable {{name}}",
  "enableName": "Enable {{name}}",
  "nameConfiguration": "{{name}} Configuration",
  "serverConfigurationEditingSection": "Server Configuration: {{editingSection}}",
  "selectName": "Select {{name}}",
  "viewDetailsForName": "View details for {{name}}",
  "thisWillReplaceALLMetadataAndImagesForNameWith": "This will replace ALL metadata and images for \"{{name}}\" with freshly downloaded data. Any manual edits will be lost.",
  "labelQueuedForName": "{{label}} queued for \"{{name}}\"",
  "labelFailed": "{{label}} failed",
  "actionsForName": "Actions for {{name}}",
  "stopPlaybackForUserName": "Stop playback for {{userName}}?",
  "thisWillStopTheCurrentPlaybackOfTitle": "This will stop the current playback of \"{{title}}\".",
  "killSessionForUserName": "Kill session for {{userName}}?",
  "sendMessageToUserName": "Send message to {{userName}}",
  "resumePlaybackForUserName": "Resume playback for {{userName}}",
  "pausePlaybackForUserName": "Pause playback for {{userName}}",
  "stopPlaybackForUserName2": "Stop playback for {{userName}}",
  "killSessionForUserName2": "Kill session for {{userName}}",
  "showAllLengthDevices": "Show all {{length}} devices",
  "purgePathPurgePath": "Purge path: {{purgePath}}",
  "labelWarnAtWarnStopAtStop": "{{label}}: warn at {{warn}}, stop at {{stop}}",
  "pathStorageUsage": "{{path}} storage usage",
  "lengthMoreLogFiles": "+{{length}} more log files",
  "releaseI": "Release {{i}}",
  "keyForTrimHasBeenCreatedOnThePrimaryServer": "Key for \"{{trim}}\" has been created on the {{primary}} server. The key will appear in the list below. Note: For security, the full key value is managed by the media server.",
  "permanentlyRevokeTheAPIKeyForAppNameAnyApplicationsUsing": "Permanently revoke the API key for \"{{appName}}\"? Any applications using this key will lose access.",
  "revokeKeyForAppName": "Revoke key for {{appName}}",
  "showAllLengthKeys": "Show all {{length}} keys",
  "rankRank": "Rank {{rank}}",
  "seriesNameEpisodePillResume": "{{seriesName}} {{episodePill}} — resume",
  "nameResume": "{{name}} — resume",
  "progressPctWatched": "{{progressPct}}% watched",
  "labelCompletion": "{{label}} completion",
  "labelWatchedEpisodesOfTotalEpisodesEpisodesTracked": "{{label}} — {{watchedEpisodes}} of {{totalEpisodes}} episodes tracked",
  "showItemI": "Show item {{i}}",
  "nameAsRole": "{{name}} as {{role}}",
  "seeAllLengthCast": "See all {{length}} cast",
  "toUpperCaseVideoCodec": "{{toUpperCase}} video codec",
  "trackIndex": "Track {{index}}",
  "versionI": "Version {{i}}",
  "chapterI": "Chapter {{i}}",
  "scanStartedForName2": "Scan started for {{name}}",
  "nameShelf": "{{name}} shelf",
  "addedFromARequestByLandedViaViaProviderId": "Added from a request by {{landedVia}} via {{providerId}}.",
  "addedFromARequestByLandedViaViaProviderId2": "Added from a request by {{landedVia}} via {{providerId}}",
  "playCountPlaysSWatchedCompletionPctAverageCompletion": "{{playCount}} plays, {{s}} watched, {{completionPct}}% average completion",
  "selectOrCreateLabel": "Select or create {{label}}...",
  "labelUpdated": "{{label}} updated",
  "failedToUpdateLabel": "Failed to update {{label}}",
  "unlockDisplayName": "Unlock {{displayName}}",
  "lockToUsernameSAccount": "Lock to {{username}}'s account",
  "deleteDisplayNameFromThisDashboard": "Delete {{displayName}} from this dashboard",
  "thisPermanentlyRemovesDisplayNameFromWSDTrackingItWillOnly": "This permanently removes \"{{displayName}}\" from WSD tracking. It will only reappear if the device connects again.",
  "thisWillBindDisplayNameToUsernameSAccountTheUser": "This will bind \"{{displayName}}\" to {{username}}'s account. The user will only be able to stream from their approved devices.",
  "thisWillRemoveDeviceRestrictionsForDisplayNameTheUserWill": "This will remove device restrictions for \"{{displayName}}\". The user will be able to stream from any device.",
  "thisWillLimitUsernameToStreamingOnlyFromTheirCurrently": "This will limit {{username}} to streaming only from their currently known devices. You can then lock/unlock individual devices below.",
  "nameLibraryAccess": "{{name}} library access",
  "includeBasenameSubFolder": "Include {{basename}} sub-folder",
  "policyFieldCountPolicy": "{{policyFieldCount}} policy",
  "configFieldCountConfig": "{{configFieldCount}} config",
  "appliedJoinFields": "Applied {{join}} fields.",
  "lengthLibrariesUnresolved": "{{length}} libraries unresolved.",
  "policyPolicyError": "Policy: {{policyError}}",
  "configConfigError": "Config: {{configError}}",
  "userNameSSettings": "{{userName}}'s Settings",
  "applyName": "Apply \"{{name}}\"?",
  "thisWillUpdateUserNameSPolicyAndConfigurationSettingsTo": "This will update {{userName}}'s policy and configuration settings to match this template. Existing values will be overwritten for any fields defined in the template.",
  "createACopyOfNameWithANewName": "Create a copy of \"{{name}}\" with a new name.",
  "permanentlyDeleteNameThisCannotBeUndone": "Permanently delete \"{{name}}\"? This cannot be undone.",
  "typeWordToConfirm": "Type {{word}} to confirm",
  "youTypedInputButWordWasRequiredActionCancelled": "You typed \"{{input}}\" but \"{{word}}\" was required. Action cancelled.",
  "labelCompleted": "{{label}} completed.",
  "requestRequestId": "Request #{{requestId}}",
  "selectDisplayName": "Select {{displayName}}",
  "lockDisplayNameToUsernameSAccount": "Lock {{displayName}} to {{username}}'s account",
  "renameDisplayName": "Rename {{displayName}}",
  "removeDisplayNameFromTheMediaServer": "Remove {{displayName}} from the media server",
  "successCountDeletedFailCountFailed": "{{successCount}} deleted, {{failCount}} failed",
  "successCountLockedFailCountFailed": "{{successCount}} locked, {{failCount}} failed",
  "syncedSyncedOfTotalFailedFailed": "Synced {{synced}} of {{total}} ({{failed}} failed)",
  "lengthOfLength2Devices": "{{length}} of {{length2}} devices",
  "lockSizeSelectedDevices": "Lock {{size}} selected devices",
  "deleteSizeSelectedDevices": "Delete {{size}} selected devices",
  "seasonI": "Season {{i}}",
  "userNameCreatedOnServerType": "User \"{{name}}\" created on {{serverType}}",
  "thisWillForcefullyStopAllCountActiveSessionSFor": "This will forcefully stop all {{count}} active session(s) for {{userName}}. This cannot be undone.",
  "youEnteredTypedButTheUsernameIsUserNameDeletionCancelled": "You entered \"{{typed}}\" but the username is \"{{userName}}\". Deletion cancelled.",
  "userDisplayNameHasBeenDeleted": "User \"{{displayName}}\" has been deleted",
  "enterANewPasswordForDisplayNameMustBeAtLeast": "Enter a new password for {{displayName}}. Must be at least 1 character.",
  "passwordHasBeenResetForDisplayName": "Password has been reset for {{displayName}}",
  "historyPurged": "{{count}} earlier fulfilled requests predate dashboard tracking; details were purged by {{provider}}.",
  "historyPurged_one": "{{count}} earlier fulfilled request predates dashboard tracking; details were purged by {{provider}}.",
  "historyPurgedFrom": "{{count}} earlier fulfilled requests from {{span}} predate dashboard tracking; details were purged by {{provider}}.",
  "historyPurgedFrom_one": "{{count}} earlier fulfilled request from {{span}} predates dashboard tracking; details were purged by {{provider}}.",
  "requestManagersUnavailable": "{{count}} request managers could not be read. Requests from those managers are missing from this list.",
  "requestManagersUnavailable_one": "{{count}} request manager could not be read. Requests from that manager are missing from this list.",
  "requestApproved": "{{label}} approved",
  "requestDeniedResult": "{{label}} denied",
  "runTaskConfirm": "Are you sure you want to run this task?",
  "stopTaskConfirm": "Are you sure you want to stop this task?",
  "taskStarted": "Task started.",
  "taskStopped": "Task stopped.",
  "typedConfirmGlobal": "This action affects all connected clients and cannot be undone. Type \"{{word}}\" to confirm.",
  "typedConfirmServer": "This action affects the server and cannot be undone. Type \"{{word}}\" to confirm.",
  "intentProceed": "Proceed with “{{action}}”?",
  "stoppedSessions": "Stopped {{count}} sessions.",
  "stoppedSessionsWithFailures": "Stopped {{count}} sessions; {{failed}} failed.",
  "markWatchedFailed": "Failed to mark item as watched",
  "markUnwatchedFailed": "Failed to mark item as unwatched",
  "markedWatched": "Marked as watched",
  "markedUnwatched": "Marked as unwatched",
  "noRequestsToShow": "No requests to show",
  "nothingMatchesTheseFilters": "Nothing matches these filters",
  "aServerScanFailed": "A server scan failed",
  "someServerScansFailed": "Some server scans failed",
  "neverScanned": "Never scanned",
  "numbersAndSymbols": "Numbers and symbols",
  "specials": "Specials",
  "billion": "1.07 billion",
  "overBillion": "over 68 billion",
  "ratingRemoved": "Rating removed",
  "ratingSaved": "Rating saved",
  "direct": "Direct",
  "noFieldsApplied": "No fields applied.",
  "streams": "∞ streams",
  "youDoNotHaveAccessToTheseRequestManagers": "You do not have access to these request managers",
  "notFound": "Not found",
  "noDevicesMatchYourFilters": "No devices match your filters",
  "noDevicesRecordedYet": "No devices recorded yet",
  "episodeAnalytics": "Episode Analytics",
  "seasonAnalytics": "Season Analytics",
  "seriesAnalytics": "Series Analytics",
  "watchingAnalytics": "Watching Analytics",
  "countValueSeasonsValueAvailable": "{{value0}} seasons · {{value1}} available",
  "countValueSeasonsValueAvailable_one": "{{value0}} season · {{value1}} available",
  "countValueSeasons": "{{value0}} seasons",
  "countValueSeasons_one": "{{value0}} season",
  "countValueDaysInactive": "{{value0}} days inactive",
  "countValueDaysInactive_one": "{{value0}} day inactive",
  "countApplyValueChangesToTheServerConfigurationThis": "Apply {{value0}} changes to the server configuration? This may require a server restart to take effect.",
  "countApplyValueChangesToTheServerConfigurationThis_one": "Apply {{value0}} change to the server configuration? This may require a server restart to take effect.",
  "countValueSeasonsValueValueTracked": "{{value0}} seasons · {{value1}}/{{value2}} tracked",
  "countValueSeasonsValueValueTracked_one": "{{value0}} season · {{value1}}/{{value2}} tracked",
  "countValueStreams": "{{value0}} streams",
  "countValueStreams_one": "{{value0}} stream",
  "countThisPermanentlyRemovesValueDevicesFromWSDTracking": "This permanently removes {{value0}} devices from WSD tracking. They will only reappear if they connect again.",
  "countThisPermanentlyRemovesValueDevicesFromWSDTracking_one": "This permanently removes {{value0}} device from WSD tracking. They will only reappear if they connect again.",
  "countDeleteValueDevices": "Delete {{value0}} devices",
  "countDeleteValueDevices_one": "Delete {{value0}} device",
  "countValueDevicesDeleted": "{{value0}} devices deleted",
  "countValueDevicesDeleted_one": "{{value0}} device deleted",
  "countThisWillBindValueDevicesToTheirRespective": "This will bind {{value0}} devices to their respective user accounts. Users will only be able to stream from approved devices.",
  "countThisWillBindValueDevicesToTheirRespective_one": "This will bind {{value0}} device to their respective user accounts. Users will only be able to stream from approved devices.",
  "countLockValueDevices": "Lock {{value0}} devices",
  "countLockValueDevices_one": "Lock {{value0}} device",
  "countValueDevicesLocked": "{{value0}} devices locked",
  "countValueDevicesLocked_one": "{{value0}} device locked",
  "countSyncedValueOfValueDeviceNames": "Synced {{value0}} of {{value1}} device names",
  "countSyncedValueOfValueDeviceNames_one": "Synced {{value0}} of {{value1}} device name",
  "countAllValueSyncsFailed": "All {{value0}} syncs failed",
  "countAllValueSyncsFailed_one": "All {{value0}} sync failed",
  "countValueDevicesSkippedServerNotConfigured": "{{value0}} devices skipped (server not configured)",
  "countValueDevicesSkippedServerNotConfigured_one": "{{value0}} device skipped (server not configured)",
  "countValueEpisodes": "{{value0}} episodes",
  "countValueEpisodes_one": "{{value0}} episode",
  "countValuePlayedItemsMatchThisViewTitlesNever": "{{value0}} played items match this view — titles never played are not shown",
  "countValuePlayedItemsMatchThisViewTitlesNever_one": "{{value0}} played item matches this view — titles never played are not shown",
  "fieldEnabled": "{{field}} enabled",
  "fieldDisabled": "{{field}} disabled",
  "expandLibrary": "Expand {{name}}",
  "collapseLibrary": "Collapse {{name}}",
  "seasonNumber": "Season {{number}}",
  "downloadingPercent": "Downloading, {{percent}} percent complete.",
  "downloadingProgress": "Downloading {{percent}}%",
  "reanalyzeWarning": "Re-analyzing on {{server}} re-probes the file but also re-downloads provider metadata — any manual metadata edits to \"{{name}}\" will be overwritten. Images are not affected.",
  "httpRequestFailed": "Request failed (HTTP {{status}})",
  "deleteDeviceCount": "Delete {{count}} devices?",
  "deleteDeviceCount_one": "Delete {{count}} device?",
  "versionAudience": "Plays: {{plays}} · Viewers: {{viewers}}",
  "inline53": "{{value0}} excluded",
  "inline54": "{{value0}}/{{value1}} libraries",
  "inline55": "{{value0}} excluded",
  "inline0": "{{value0}} of {{value1}}",
  "inline58": "{{value0}} total",
  "inline59": "Available Templates ({{value0}})",
  "inline4": "{{value0}} days",
  "inline5": "No devices inactive for {{value0}}+ days.",
  "inline6": "{{value0}} candidates",
  "inline6_one": "{{value0}} candidate",
  "inline7": "{{value0}} tags",
  "inline7_one": "{{value0}} tag",
  "inline32": "{{value0}} items {{value1}}",
  "inline32_one": "{{value0}} item {{value1}}",
  "inline47": "Set a new password for {{value0}}.",
  "inline48": "Permanently remove {{value0}} from the server.",
  "inline2": "not in your library yet {{value0}}",
  "inline51": "Watch history: {{value0}}",
  "inline52": "({{value0}} total)",
  "inline36": "{{value0}} locations",
  "inline36_one": "{{value0}} location",
  "inline37": "{{value0}} countries",
  "inline37_one": "{{value0}} country",
  "inline38": "{{value0}} plays",
  "inline38_one": "{{value0}} play",
  "inline39": "{{value0}} plays",
  "inline39_one": "{{value0}} play",
  "inline63": "Ch {{value0}}",
  "inline64": "{{value0}} plays across {{value1}} file versions",
  "inline10": "Last active: {{value0}}",
  "inline40": "{{value0}}-bit",
  "inline41": "{{value0}} tracks",
  "inline41_one": "{{value0}} track",
  "inline42": "{{value0}} tracks",
  "inline42_one": "{{value0}} track",
  "inline43": "{{value0}}-bit",
  "inline19": "{{value0}} — Scheduled tasks not supported",
  "inline20": "{{value0}} tasks",
  "inline21": "{{value0}} plugins installed",
  "inline21_one": "{{value0}} plugin installed",
  "inline22": "{{value0}} total keys",
  "inline23": "{{value0}} configuration keys loaded",
  "inline65": "{{value0}} stores no title against a request, so this is shown by its external id.",
  "inline66": "{{value0}} records this against the request, so the requester can see why.",
  "inline8": "Last active: {{value0}}",
  "inline9": "User policies on {{value0}} are managed via plex.tv (Account → Sharing). Policy changes here are not applied for {{value1}} users.",
  "inline11": "{{value0}}/{{value1}} intents live",
  "inline12": "Emby ({{value0}})",
  "inline13": "Jellyfin ({{value0}})",
  "inline14": "Plex ({{value0}})",
  "inline15": "{{value0}}/{{value1}} live",
  "inline35": "{{value0}}x",
  "inline49": "since {{value0}}",
  "inline50": "Devices ({{value0}})",
  "inline44": "{{value0}}x",
  "inline45": "not in this library yet {{value0}}",
  "inline57": "Active Sessions ({{value0}})",
  "inline17": "{{value0}} total results",
  "inline18": "{{value0}} selected",
  "inline16": "{{value0}}/{{value1}} active",
  "inline60": "since {{value0}}",
  "inline61": "{{value0}} selected",
  "inline62": "Devices ({{value0}})",
  "inline1": "Requested by {{value0}}",
  "inline67": "Set a new password for {{value0}}.",
  "inline68": "Permanently remove {{value0}} from the media server.",
  "inline33": "{{value0}}/{{value1}} tracked",
  "inline34": "{{value0}}/{{value1}} tracked",
  "inline46": "{{value0}} tags",
  "inline46_one": "{{value0}} tag",
  "inline24": "{{value0}} Streams",
  "inline24_one": "{{value0}} Stream",
  "inline25": "{{value0}} Streams",
  "inline25_one": "{{value0}} Stream",
  "inline26": "View all {{value0}} sessions on Live Dashboard",
  "inline27": "Last purge: {{value0}}",
  "inline28": "Warn {{value0}} / Stop {{value1}}",
  "inline29": "+{{value0}} more entries",
  "inline30": "{{value0}} free of {{value1}}",
  "inline31": "{{value0}}% used",
  "inline3": "Showing {{value0}} of {{value1}} already in your library",
  "removeUpstreamDevice": "This removes \"{{device}}\" from your {{server}} server and deletes its device registration there. It does not just hide the device locally. The device can register again if it reconnects.",
  "deleteUserConfirmation": "This will permanently delete {{name}} from the {{server}} server. Type {{name}} exactly (case-sensitive) to confirm.",
  "includedFields": "{{count}} fields included",
  "includedFields_one": "{{count}} field included",
  "libraryAccessCounts": "Libraries: {{enabled}} / Excluded: {{excluded}}",
  "openProvider": "Open in {{provider}}",
  "tVStreaming": "TV & Streaming",
  "eGStandardUserRestrictedAccess": "e.g. Standard User, Restricted Access...",
  "dLNABuiltIn": "DLNA (built-in)",
  "error": "Error",
  "eGMoviesTVShows": "e.g., Movies, TV Shows",
  "eGMovies": "e.g., Movies",
  "series": "Series",
  "backoffUntil": "Backoff until",
  "serverStorage": "Server Storage",
  "eGMyCustomApp": "e.g. My Custom App",
  "templateFieldHelp": "Each field has a checkbox that controls whether it is included in the template. Unchecked fields are skipped when applying the template — the existing user setting is kept.",
  "enableControlCenter": "Enable WSDashboard in {{location}} to access the Control Center.",
  "enableMediaPortal": "Enable WSDashboard in {{location}} to access the Media Portal.",
  "otherVersionAnalytics": "Other versions of this title may have play history. Select {{action}} to see aggregated analytics across every file copy.",
  "directorHeading": "Directors",
  "directorHeading_one": "Director",
  "writerHeading": "Writers",
  "writerHeading_one": "Writer",
  "unsavedChanges": "{{count}} unsaved changes",
  "unsavedChanges_one": "{{count}} unsaved change",
  "registeredKeys": "{{count}} keys registered",
  "registeredKeys_one": "{{count}} key registered",
  "historyEntries": "({{count}} entries)",
  "historyEntries_one": "({{count}} entry)",
  "playCount": "{{count}} plays",
  "playCount_one": "{{count}} play",
  "deviceCount": "{{count}} devices",
  "deviceCount_one": "{{count}} device",
  "colorDepth": "{{depth}}-bit color depth provides {{colors}} possible colors",
  "audioChannels": "{{count}} channels ({{layout}})",
  "audioChannels_one": "{{count}} channel ({{layout}})",
  "stereo": "Stereo",
  "mono": "Mono",
  "identifyReplacementWarning": "This rewrites the identity of “{{item}}” to match “{{match}}”. All metadata is replaced with the new match and any manual edits are lost.",
  "viewInServer": "View in {{server}}",
  "seriesContinuing": "Continuing",
  "seriesEnded": "Ended",
  "residualShelfAwaiting": "Awaiting decision",
  "residualShelfDownloading": "Downloading now",
  "residualShelfApproved": "Recently approved",
  "residualShelfAvailable": "Now available",
  "residualShelfFulfilled": "Previously requested",
  "residualShelfDeclined": "Declined",
  "residualSeason": "Season {{season}}",
  "residualNotRequested": "Not requested",
  "residualInstalledFor": "Installed for {{owners}}",
  "residualLibraryCount": "There are {{count}} items in the {{library}} library",
  "residualLibraryCount_one": "There is {{count}} item in the {{library}} library",
  "residualLibraryCount_other": "There are {{count}} items in the {{library}} library",
  "residualAnalysisStarted": "Analysis started for \"{{name}}\"",
  "residualReprobeQueued": "Re-probe refresh queued for \"{{name}}\"",
  "residualThemeMap": "Matches the dashboard theme",
  "residualDarkMap": "Dark map",
  "residualLightMap": "Light map",
  "residualStreetMap": "Street map",
  "residualSatelliteMap": "Satellite map",
  "residualBrowser": "Browser",
  "residualSmartTv": "Smart TV",
  "residualAnalyzeHelp": "Re-scan media properties and markers",
  "residualReprobeHelp": "Re-probe file (replaces provider metadata)",
  "guideHeading": "TV Guide",
  "guideNow": "Now",
  "guideNext": "Next",
  "guideNewBadge": "New",
  "guideLiveBadge": "Live",
  "guideNoTitle": "No programme information",
  "guideUnknownChannel": "Unknown channel",
  "guideProgressPercent": "Programme {{percent}} percent complete",
  "guideDisabled": "The IPTVBoss guide is turned off in Streaming Settings.",
  "guideNoExport": "No guide yet. Turn on an XMLTV output in the IPTVBoss editor to see what’s on.",
  "guideNoMatch": "This channel isn’t in your TV guide.",
  "guideError": "The guide couldn’t be read right now.",
  "tvGuideSubtitle": "Browse the full channel-by-time programme guide from IPTVBoss and Dispatcharr.",
  "tvGuideNotInstalledTitle": "No guide source yet",
  "tvGuideNotInstalledBody": "The TV Guide reads channels and programmes from IPTVBoss or Dispatcharr. Install either app, or add a Dispatcharr connection in Streaming Settings.",
  "tvGuideNoChannels": "No channels match",
  "tvGuideNoChannelsBody": "No channels match the current group or search. Clear the filters to see the full guide.",
  "tvGuideAllGroups": "All groups",
  "tvGuideGroupLabel": "Filter by group",
  "tvGuideSearchPlaceholder": "Search channels",
  "tvGuideEarlier": "Earlier",
  "tvGuideLater": "Later",
  "tvGuideLoadMore": "Load more channels",
  "tvGuideChannelCount": "Showing {{shown}} of {{total}} channels",
  "tvGuideGridLabel": "Programme guide",
  "tvGuideWindowLabel": "Window length",
  "tvGuideWindowHours": "{{hours}} hours",
  "tvGuidePageSizeLabel": "Channels per page",
  "tvGuidePageSizeOption": "{{count}} / page",
  "tvGuideHideEmpty": "Hide empty channels",
  "tvGuideHideEmptyLabel": "Hide channels without guide data",
  "tvGuideFilters": "Filters",
  "tvGuideRowNoData": "No guide data",
  "tvGuideSummaryWithData": "Showing {{shown}} of {{total}} channels with guide data ({{totalChannels}} total)",
  "tvGuideProviderLabel": "Filter by provider",
  "tvGuideAllProviders": "All providers",
  "tvGuideProviderOption": "{{name}} ({{channels}})",
  "tvGuideUnknownProvider": "Unknown provider",
  "watchingNowHeading": "Watching now",
  "liveNowHeading": "Live now",
  "liveNowNoOne": "No one is watching live TV",
  "liveNowStreams": "Streams",
  "liveNowChannels": "Channels",
  "liveNowProviders": "Providers",
  "liveNowPlaying": "{{count}} playing",
  "liveNowPaused": "{{count}} paused",
  "liveNowStreamsTitle": "Live streams",
  "liveNowChannelsTitle": "Live channels",
  "liveNowProvidersTitle": "Live providers",
  "liveNowWatching": "{{count}} watching",
  "liveNowProviderStreams": "{{count}} streams",
  "liveNowDirect": "Direct",
  "liveNowTranscode": "Transcode",
  "liveNowStop": "Stop",
  "liveNowBandwidthLabel": "Bandwidth",
  "liveNowMbps": "{{value}} Mbps",
  "liveNowTopProgrammeLabel": "Most watched",
  "liveTrendsTab": "Trends",
  "liveTrendsWindow24h": "last 24 hours",
  "liveTrendsWindow7d": "last 7 days",
  "liveTrendsWindow30d": "last 30 days",
  "liveTrendsTrendingNone": "not enough data",
  "liveTrendsUnattributedCaption": "before channel tracking",
  "liveTrendsPeriodLabel": "Period",
  "liveTrendsPeriod24h": "24h",
  "liveTrendsPeriod7d": "7d",
  "liveTrendsPeriod30d": "30d",
  "liveTrendsTopChannels": "Top channels",
  "liveTrendsTopProviders": "Top providers",
  "liveTrendsTopProgrammes": "Top programmes",
  "liveTrendsWhenWatched": "When people watch",
  "liveTrendsSharePct": "{{value}}%",
  "liveTrendsViewersLabel": "Viewers",
  "liveTrendsWatchHoursLabel": "Watch hours",
  "liveTrendsUnattributed": "Unattributed",
  "liveTrendsUnattributedNote": "Viewing recorded before this feature is not attributed to a channel.",
  "liveTrendsEmpty": "No live viewing in this period.",
  "liveTrendsLoadFailed": "Could not load trends.",
  "liveTrendsLoading": "Loading trends…",
  "liveTrendsPeakConcurrent": "Peak",
  "liveTrendsTrendingNow": "Trending",
  "liveTrendsTrendingDelta": "{{recent}} now vs {{usual}} typical",
  "liveTrendsHeatmapDesc": "Live viewing by day of week and hour of day.",
  "liveTrendsHeatmapCell": "{{weekday}} {{hour}}: {{value}} h",
  "liveTrendsHeatmapSummary": "Busiest on {{weekday}} around {{hour}}.",
  "liveTrendsHeatmapLess": "Less",
  "liveTrendsHeatmapMore": "More",
  "liveTrendsPerViewerHours": "{{value}} h this period",
  "liveTrendsFavourite": "Favourite: {{channel}}",
  "tvGuideFiltersActive": "{{count}} active filters",
  "tvGuideFiltersActive_one": "{{count}} active filter",
  "tvGuideClearFilters": "Clear filters",
  "liveNowPlayback": "Playback",
  "liveNowServersLabel": "Servers",
  "liveNowStreamCount": "{{count}} streams",
  "liveNowTabLive": "Live",
  "liveNowTopChannel": "Top: {{name}}",
  "liveNowTopProvider": "Top: {{name}}",
  "liveNowTranscodingCount": "{{count}} transcoding",
  "liveNowPausedBadge": "Paused",
  "liveNowDeviceLabel": "Device",
  "liveNowLocationLabel": "Location",
  "liveTrendsTotalHours": "Watch time",
  "liveTrendsBusiestHourLabel": "Busiest",
  "liveTrendsTopViewers": "Top viewers",
  "liveTrendsChannelDetailLabel": "Channel detail",
  "liveTrendsChannelDetailSince": "since {{when}}",
  "liveTrendsChannelDetailStartsNew": "starts with new viewing",
  "liveTrendsChannelDetailNote": "Channel and provider detail is recorded for viewing since {{date}}; earlier viewing is in the totals and programmes.",
  "liveTrendsChannelDetailNoteNew": "Channel and provider detail starts with new viewing; earlier viewing is in the totals and programmes.",
  "liveTrendsUntitledNote": "{{hours}} of viewing had no programme title.",
  "liveTrendsTuners": "Tuners",
  "liveTrendsHeatmapSummaryHour": "Busiest around {{hour}}.",
  "liveTrendsHourlyCell": "{{hour}}: {{value}} h",
  "liveTrendsPanelError": "Trends could not be shown.",
  "liveTrendsHeatmapUnavailable": "Not enough data to chart when people watch.",
  "liveTrendsScrollHint": "Click to scroll",
  "liveTrendsProvidersGroup": "Providers",
  "liveTrendsTunersGroup": "Tuners",
  "liveTrendsShareOfViewing": "Share of viewing",
  "liveTrendsShareSegment": "{{name}}: {{pct}}% of viewing, {{hours}} h",
  "liveTrendsClickInteract": "Click to interact",
  "liveTrendsClickInteractSub": "Scroll and open these metrics",
  "liveTrendsSparklinePoint": "{{when}} · {{value}}",
  "liveTrendsSparklineAria": "Watch-hours trend",
  "liveTrendsTrendingQuiet": "nothing surging right now",
  "liveTrendsTrendingBuilding": "no channel history yet",
  "liveTrendsTrendingRule": "A channel trends when at least 2 people are watching it at once and that is twice its usual audience. A channel with no viewing history yet trends as soon as 2 people watch it together.",
  "artworkSectionTitle": "Artwork",
  "artworkTabPosters": "Posters",
  "artworkTabBanners": "Banners",
  "artworkTabBackgrounds": "Backgrounds",
  "artworkCurrentBadge": "Current",
  "artworkGalleryRegion": "Artwork gallery",
  "artworkOpenFullSize": "Open full size",
  "artworkPrevImage": "Previous image",
  "artworkNextImage": "Next image",
  "artworkCloseViewer": "Close viewer",
  "artworkImageCounter": "{{position}} of {{total}}",
  "artworkViewerAria": "Artwork viewer",
  "artworkBackgroundN": "Background {{n}}",
  "backToDevices": "Back to devices",
  "failedToLoadDevice": "Failed to load device",
  "deviceNotFound": "Device not found",
  "deviceNotFoundOnServer": "No device with this id was found on {{server}}.",
  "users": "Users",
  "network": "Network",
  "nameHistory": "Name History",
  "platform": "Platform",
  "lastSeenLabel": "Last Seen",
  "accessState": "Access",
  "unlocked": "Unlocked",
  "openInServer": "Open in {{server}}",
  "usedByAccounts": "Accounts using this device",
  "noAccountRegisters": "No account currently registers this device.",
  "noUsersRecorded": "No users recorded",
  "noIpHistory": "No IP history recorded",
  "noNameChanges": "No name changes recorded",
  "noWatchHistoryForDevice": "No watch history for this device",
  "loadMore": "Load more",
  "deviceDetailTabs": "Device detail tabs",
  "sessionsCountLabel": "{{count}} sessions",
  "seenCountLabel": "{{count}} connections",
  "sessionsCountLabel_one": "{{count}} session",
  "seenCountLabel_one": "{{count}} connection",
  "openProfileForUserName": "Open profile for {{userName}}",
  "listTruncatedNote": "Showing the first {{shown}} of {{total}}"
} as const;
